
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import BacMenu from './BacMenu.vue'
import BacRallyRoundDateSubHeader from './BacRallyRoundDateSubHeader.vue'

import Chat from '@/views/Chat.vue'
import Teams from '@/views/Teams.vue'
import Base from '@/views/Base.vue'

@Component({
  components: {
    BacMenu,
    BacRallyRoundDateSubHeader,

    Chat,
    Teams,
    Base
  }
})
export default class BacHeaderWithMenu extends Vue {
  @Prop({ default: false }) injectTeamarea!: boolean
  @Prop({ default: 'true' }) visible!: string;
  // teamAreaLink = '/base/';
  // allTeamsLink = '/teams';
  // rodeoLiveLink = '/rally.php';
  queryString = window.location.search;
  pathname = window.location.pathname;
  rallyRoundId = this.$route.params.rallyRoundId

  activeTab = this.pathname.split('/teamarea')[1]

  tabsChanged = 0

  get tabs () {
    return [
      { id: 1, name: 'Base', to: this.getTabPath('Base') },
      { id: 2, name: this.participantsName, to: this.getTabPath('Teams') },
      { id: 3, name: 'Live', to: this.getTabPath('Chat') }
    ]
  }

  getTabPath (name: string) {
    // Get the path without losing params. Usefull e.g. if you have a :locale in your url:
    return this.$router.resolve({ name, params: this.$route.params }).href.split('/teamarea')[1]
  }

  updateRouter (path: string) {
    // Gets called upon swipe.
    this.$router.push(path)
  }

  get teamAreaLink () {
    // DISABLE EXCEPT ADMIN return this.$store.state.LoggedInUser.user.isAdmin ? `/base/${this.rallyRoundId}` : `/waiting/${this.rallyRoundId}`
    const link = `/base/${this.rallyRoundId}`
    return link
  }

  get allTeamsLink () {
    const link = `/teams/${this.rallyRoundId}`
    return link
  }

  get rodeoLiveLink () {
    const link = `/rally/${this.rallyRoundId}`
    return link
  }

  get participantsName (): string {
    if (!this.$store.state.PageURLRallyRound.rallyRound) {
      return ''
    }
    return this.$store.state.PageURLRallyRound.rallyRound.teamname
  }

  get customer () {
    if (!this.$store.state.LoggedInUser.user.id) {
      this.$store.dispatch('loadLoggedInUser')
      return ''
    } else {
      return this.$store.state.LoggedInUser.user
    }
  }

  get cssProps () {
    return {
      '--visible': this.visible
    }
  }

  mounted () {
    if (this.$store.state.PageURLRallyRound.rallyRound.id) {
      this.rallyRoundId = this.$store.state.PageURLRallyRound.rallyRound.id
      this.queryString = `?rid=${this.$store.state.PageURLRallyRound.rallyRound.rallyId}&rrid=${this.$store.state.PageURLRallyRound.rallyRound.id}`
    }
    if (this.$route.params.rallyRoundId) {
      this.$store.dispatch('loadRallyRound', this.$route.params.rallyRoundId)
    } else {
      this.$store.dispatch('loadRallyRound')
    }
    setInterval(this.setHeaderOffset, 500)

    setTimeout(() => {
      if ((document.getElementsByClassName('base-button').length === 0 || !(document.getElementsByClassName('base-button')[0] as HTMLElement).offsetParent) &&
       this.pathname.includes('base')) {
        this.tabsChanged++
      }
    }, 1000)
    this.setHeaderOffset()
  }

  /* unmounted () {
    this.tabsChanged++
  } */

  @Watch('activeTab')
  setHeaderOffset () {
    const headers = document.getElementsByTagName('header')
    if (!headers.length) {

    }
    if (this.$refs.content && (this.$refs.content as []).length) {
      (this.$refs.content as HTMLElement[]).forEach(element => {
        element.style.paddingTop = headers[0].getClientRects()[0].height + 'px'
      })
    } else if (this.$refs.content) {
      (this.$refs.content as HTMLElement).style.paddingTop = headers[0].getClientRects()[0].height + 'px'
    }
  }

  @Watch('$store.state.PageURLRallyRound.rallyRound')
  onRallyRoundChange () {
    this.$store.dispatch('loadRally', this.$store.state.PageURLRallyRound.rallyRound.rallyId)
    this.queryString = `?rid=${this.$store.state.PageURLRallyRound.rallyRound.rallyId}&rrid=${this.$store.state.PageURLRallyRound.rallyRound.id}`
    this.rallyRoundId = this.$store.state.PageURLRallyRound.rallyRound.id
  }

  refreshQueryStringAndPathname () {
    this.queryString = window.location.search
    this.pathname = window.location.pathname
  }
}
